import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const dynamicStyles = (
  fontSize = 24,
  fontWeight = 500,
  spaceY: string
) => css`
  color: ${colors.white};
  margin-top: ${spaceY}px;
  font-weight: ${fontWeight};
  position: relative;
  ${MQ.MobileXs} {
    ${ZeeFontBold(16, 22)};
  }
  ${MQ.MediaWeb} {
    ${ZeeFontBold(18, 26)};
  }
  ${MQ.MediaSm} {
    ${ZeeFontBold(18, 24)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(fontSize, 36)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(36, 48)};
  }
`;

export const titleWrapper = css`
  ${flex('row', 'flex-start')};
  gap: 8px;
  flex-wrap: wrap;
`;
